import { defineMessages } from 'react-intl';

export const subItemQuantityEventMessages = defineMessages({
    quantityEvents: {
        id: 'quantity-events',
        defaultMessage: 'Quantity events',
    },
    quantityEvent: {
        id: 'quantity-event',
        defaultMessage: 'Quantity event',
    },
    quantityEventTableBadge: {
        id: 'quantity-event-table-badge',
        defaultMessage: 'Event',
    },
    quantityEventsTableBadge: {
        id: 'quantity-events-table-badge',
        defaultMessage: 'Events',
    },
    recordedAt: {
        id: 'recorded-at',
        defaultMessage: 'Recorded at',
    },
    eventType: {
        id: 'event-type',
        defaultMessage: 'Event type',
    },
    quantity: {
        id: 'quantity',
        defaultMessage: 'Quantity',
    },
    set: {
        id: 'set',
        defaultMessage: 'Set',
    },
    increment: {
        id: 'increment',
        defaultMessage: 'Increment',
    },
    decrement: {
        id: 'decrement',
        defaultMessage: 'Decrement',
    },
    addQuantityEventSubtitle: {
        id: 'add-quantity-event-subtitle',
        defaultMessage: 'Record a change in the measured quantity for this item.',
    },
    quantityHint: {
        id: 'quantity-event-quantity-hint',
        defaultMessage: 'For "set" this is the new total. For "increment" and "decrement" it is how much to change by.',
    },
    createQuantityEventSuccess: {
        id: 'create-quantity-event-success',
        defaultMessage: 'Quantity event recorded',
    },
    createQuantityEventSuccessDescription: {
        id: 'create-quantity-event-success-description',
        defaultMessage: 'The quantity event has been successfully recorded.',
    },
    deleteQuantityEvent: {
        id: 'delete-quantity-event',
        defaultMessage: 'Delete quantity event',
    },
    deleteQuantityEventSubtitle: {
        id: 'delete-quantity-event-subtitle',
        defaultMessage: 'The measured quantity will be recalculated without it.',
    },
    confirmDeleteQuantityEvent: {
        id: 'confirm-delete-quantity-event',
        defaultMessage: 'Are you sure you want to delete this quantity event?',
    },
    deleteQuantityEventSuccess: {
        id: 'delete-quantity-event-success',
        defaultMessage: 'Quantity event deleted',
    },
    deleteQuantityEventSuccessDescription: {
        id: 'delete-quantity-event-success-description',
        defaultMessage: 'The quantity event has been successfully deleted.',
    },
});
